import React from "react";
import { useLocation } from "react-router";
import ProductItem from "theme/modules/ProductView/ProductItem";
import ProductItemSkeleton from "theme/modules/ProductView/ProductItem/ProductItemSkeleton";

const LayerProducts = ({
  loading,
  layer,
  hasFilters,
  EmptyComponent,
  breadcrumb,
  imageSizes,
  prioritizeTop = 0,
}) => {
  const location = useLocation();

  if (loading) {
    return (
      <div className="layer-products">
        {new Array(5).fill(null).map((_, index) => (
          <div key={index} className="layer-products__element">
            <ProductItemSkeleton />
          </div>
        ))}
      </div>
    );
  }

  if (layer.products.length === 0) {
    return <EmptyComponent hasFilters={hasFilters} />;
  }

  return (
    <div className="layer-products">
      {layer.products.map((product, index) => {
        return (
          <div key={product.sku} className="layer-products__element">
            <ProductItem
              key={product.sku}
              product={product}
              {...product}
              products={layer.products}
              location={location}
              index={index}
              breadcrumb={breadcrumb}
              imageSizes={imageSizes}
              imagePriority={index < prioritizeTop}
            />
          </div>
        );
      })}
    </div>
  );
};

export default LayerProducts;
